import { get, post, put, del } from "../common/apiClient";

const PATH = "/topics";

export const getTopics = () => get(PATH);
export const createTopic = (name, icon = "") => post(PATH, { name, icon });
export const updateTopic = (id, name, icon) => put(`${PATH}/${id}`, { name, ...(icon !== undefined && { icon }) });
export const deleteTopic = (id) => del(`${PATH}/${id}`);
